module.exports = __webpack_public_path__ + "img/pin.6dd9fcbc.svg";